"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@dnd-kit/core");
var _sortable = require("@dnd-kit/sortable");
var _modifiers = require("@dnd-kit/modifiers");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Checkbox = require("../form/Checkbox");
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _numberFormatter = require("../../helpers/numberFormatter");
require("./MarginAssetOptionsDnd.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('repay-loan-modal');
function SortableItem(_ref) {
  var _transform$x, _transform$y;
  var id = _ref.id,
    ProductSymbol = _ref.ProductSymbol,
    ProductFullName = _ref.ProductFullName,
    Amount = _ref.Amount,
    NotionalValue = _ref.NotionalValue,
    DecimalPlaces = _ref.DecimalPlaces,
    baseNotionalDecimalPlaces = _ref.baseNotionalDecimalPlaces,
    checked = _ref.checked,
    onCheckboxChange = _ref.onCheckboxChange;
  var _useSortable = (0, _sortable.useSortable)({
      id: id
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var style = {
    transform: "translate3d(".concat((_transform$x = transform === null || transform === void 0 ? void 0 : transform.x) !== null && _transform$x !== void 0 ? _transform$x : 0, "px, ").concat((_transform$y = transform === null || transform === void 0 ? void 0 : transform.y) !== null && _transform$y !== void 0 ? _transform$y : 0, "px, 0)"),
    transition: transition
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: setNodeRef,
    className: bemClasses('repay-option-row'),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('checkbox-and-details-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onPointerDown: function onPointerDown(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    checked: checked,
    onChange: function onChange() {
      return onCheckboxChange(id);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('product-info')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('product-name')
  }, ProductSymbol, " - ", ProductFullName))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('amounts-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('amount')
  }, (0, _numberFormatter.formatNumberToLocale)(Amount, DecimalPlaces)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('notional-value')
  }, "\u2248", (0, _numberFormatter.formatNumberToLocale)(NotionalValue, baseNotionalDecimalPlaces))), /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: bemClasses('drag-icon-container')
  }, attributes, listeners), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "drag",
    className: bemClasses
  })));
}
var MarginAssetOptionsDnd = function MarginAssetOptionsDnd(_ref2) {
  var repaymentOptions = _ref2.repaymentOptions,
    onAssetOptionsOrderChange = _ref2.onAssetOptionsOrderChange,
    onCheckboxChange = _ref2.onCheckboxChange,
    baseNotionalDecimalPlaces = _ref2.baseNotionalDecimalPlaces;
  var handleDragEnd = function handleDragEnd(event) {
    var active = event.active,
      over = event.over;
    if (!over || active.id !== over.id) {
      onAssetOptionsOrderChange(function (items) {
        var oldIndex = items.findIndex(function (item) {
          return item.id === active.id;
        });
        var newIndex = items.findIndex(function (item) {
          return item.id === over.id;
        });
        return (0, _sortable.arrayMove)(items, oldIndex, newIndex);
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    collisionDetection: _core.closestCenter,
    onDragEnd: handleDragEnd,
    modifiers: [_modifiers.restrictToParentElement]
  }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
    items: repaymentOptions,
    strategy: _sortable.verticalListSortingStrategy
  }, repaymentOptions.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(SortableItem, {
      key: item.ProductId,
      id: item.ProductId,
      ProductSymbol: item.ProductSymbol,
      ProductFullName: item.ProductFullName,
      Amount: item.Amount,
      NotionalValue: item.NotionalValue,
      DecimalPlaces: item.DecimalPlaces,
      baseNotionalDecimalPlaces: baseNotionalDecimalPlaces,
      checked: item.checked,
      onCheckboxChange: onCheckboxChange
    });
  })));
};
MarginAssetOptionsDnd.propTypes = {
  repaymentOptions: _propTypes["default"].array,
  onAssetOptionsOrderChange: _propTypes["default"].func,
  onCheckboxChange: _propTypes["default"].func,
  baseNotionalDecimalPlaces: _propTypes["default"].number
};
var _default = exports["default"] = MarginAssetOptionsDnd;